import { Observable } from 'rxjs';

import { Translation } from '../models';

export abstract class TranslationContentService {
    /**
     * Provides an observable will all available fallback translations.
     */
    abstract getTranslation(): Observable<Translation[]>;

    /**
     * Provides an observable will all available translations for the current tenant.
     */
    abstract getTenantTranslation(): Observable<Translation[]>;
}
